import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../api/axios';
import { useAuth } from '../context/AuthContext';

const usePageTracking = () => {
    const location = useLocation();
    const { user } = useAuth();

    useEffect(() => {
        if (user) {
            const logInteraction = async () => {
                try {
                    // Extract a clean page name from the path
                    const pageName = location.pathname === '/' ? 'agenda' : location.pathname.substring(1);
                    
                    await api.post('/sessions/log', {
                        page_name: pageName,
                        action_type: 'navigation'
                    });
                } catch (error) {
                    console.error("Error logging navigation", error);
                }
            };

            logInteraction();
        }
    }, [location, user]);
};

export default usePageTracking;
